import React from 'react';
import styles from './InternalAdminTool.module.scss';
import LogoHeader from './components/LogoHeader';
import CustomerDetails from './components/CustomerDetails';
import { CustomerForInternalAdminTool } from '../types/CustomerForInternalAdminTool';

interface AlreadyConnectedViewProps {
  organisationId: string;
  accTickImage: string;
  accessLogoTickImage: string;
  customer: CustomerForInternalAdminTool;
  corporateSite: string;
  setSelectedCustomer: (customer: CustomerForInternalAdminTool | null) => void;
}

const AlreadyConnectedView: React.FC<AlreadyConnectedViewProps> = ({
  organisationId,
  accTickImage,
  accessLogoTickImage,
  customer,
  corporateSite,
  setSelectedCustomer
}) => {
  return (
    <div className={styles.container}>
      <LogoHeader
        accTickImage={accTickImage}
        accessLogoTickImage={accessLogoTickImage}
        organisationId={organisationId}
        corporateSite={corporateSite}
      />
      
      <div className={styles.resultsContainer}>
        <CustomerDetails
          foundCustomer={customer}
          title="Connected"
          hideLinkedStatus={true}
          setSelectedCustomer={setSelectedCustomer}
        />
      </div>
    </div>
  );
};

export default AlreadyConnectedView;
